export default __webpack_public_path__ + "static/media/vinyl_light.75f093fa.png";